/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import "./EnquiryPage.css";
import {
  useAppDispatch,
  useLoginUserData,
  useRegisterUserData,
  useEnquiryData,
  useGetBusinessData,
  useSelectedCity,
} from "../../../Utility";
import {
  onEnquiryPost,
  onEnquiryPostReset,
} from "../../../Store/Slices/enquirySlice";
import { onGetBusinesses } from "../../../Store/Slices/businessSlice";
import {
  capsFirstLetter,
  isLoggedIn,
  tranformBusinessData,
} from "../../../utils/UtilityFunctions";
import {
  cities,
} from "../../../config/appData";

const EVENT_TYPES = [
  { value: "", label: "Select event type" },
  { value: "wedding", label: "Wedding" },
  { value: "engagement", label: "Engagement" },
  { value: "anniversary", label: "Anniversary" },
  { value: "birthday", label: "Birthday" },
  { value: "corporate", label: "Corporate / Conference" },
  { value: "other", label: "Other" },
];

const TRUST_ITEMS = [
  { icon: "✓", text: "Response within 24 hours" },
  { icon: "✓", text: "Curated venues & vendors" },
  { icon: "✓", text: "No spam, ever" },
];

function EnquiryPage() {
  const isLogin = isLoggedIn();
  const dispatch = useAppDispatch();
  const city = useSelectedCity();
  const businessData = useGetBusinessData();
  const loginUserData = useLoginUserData()?.loginData?.user;

  const enquiryData = useEnquiryData();
  const registerData = useRegisterUserData()?.registerData?.user;
  const venueIdParam = new URLSearchParams(window.location.search).get(
    "venueId",
  );
  const vendorIdParam = new URLSearchParams(window.location.search).get(
    "vendorId",
  );
  const venueId =
    venueIdParam != null && Number.isFinite(parseInt(venueIdParam, 10))
      ? parseInt(venueIdParam, 10)
      : vendorIdParam != null && Number.isFinite(parseInt(vendorIdParam, 10))
        ? parseInt(vendorIdParam, 10)
        : null;
        const businessesList =
    tranformBusinessData(businessData?.businessesList, venueIdParam ? true : false) ?? [];
  const allBusinessesList =
    tranformBusinessData(businessData?.businessesList, false, true) ?? [];
  useEffect(() => {
    if (isLogin) {
      if (loginUserData) {
        setFormData((prev) => ({
          ...prev,
          name: loginUserData?.name,
          email: loginUserData?.email,
          phone: loginUserData?.phone,
        }));
      }
      if (registerData) {
        setFormData((prev) => ({
          ...prev,
          name: registerData?.name,
          email: registerData?.email,
          phone: registerData?.phone,
        }));
      }
    }
    if (venueId) {
      setFormData((prev) => ({
        ...prev,
        reference_id: businessesList?.find((v) => v?.id === venueId)?.id,
        type: businessesList?.find((v) => v?.id === venueId)?.type,
      }));
    }
    if (city) {
      setFormData((prev) => ({
        ...prev,
        city: city,
      }));
    }
  }, [loginUserData, registerData, isLogin, city]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    eventdate: "",
    eventtype: "",
    nooguests: "",
    city: "",
    venuePref: "",
    budget: "",
    descrip: "",
    interestType: "",
    vendorType: "",
    venueType: "",
    reference_id: "",
    type: "",
    selectedVendorId: "",
    selectedVenueId: "",
  });

  const [errors, setErrors] = useState({});
  const [showThankYou, setShowThankYou] = useState(false);
  const isSubmitting = enquiryData?.postLoading;

  const hasStep1City = !!formData.city?.trim();
  const cityNorm = (formData.city || "").trim().toLowerCase();
  const businessesInCity = useMemo(() => {
    if (!cityNorm) return [];
    return (allBusinessesList || []).filter(
      (b) => (b.city || "").toLowerCase() === cityNorm,
    );
  }, [allBusinessesList, cityNorm]);
  const vendorTypeOptionsDynamic = useMemo(() => {
    const vendors = businessesInCity.filter((b) => b?.businessType === "vendor");
    const types = [...new Set(vendors.map((b) => b.type).filter(Boolean))].sort();
    return types.map((t) => ({
      value: t,
      label: capsFirstLetter((t || "").replace(/-/g, " ")),
    }));
  }, [businessesInCity]);
  const venueTypeOptionsDynamic = useMemo(() => {
    const venues = businessesInCity.filter((b) => b?.businessType === "venue");
    const types = [...new Set(venues.map((b) => b.type).filter(Boolean))].sort();
    return types.map((t) => ({
      value: t,
      label: capsFirstLetter((t || "").replace(/-/g, " ")),
    }));
  }, [businessesInCity]);
  const vendorsListForSelect = useMemo(() => {
    if (formData.interestType !== "vendor" || !formData.vendorType) return [];
    return businessesInCity.filter(
      (b) =>
        b?.businessType === "vendor" &&
        (b.type || "").toLowerCase() === (formData.vendorType || "").toLowerCase(),
    );
  }, [businessesInCity, formData.interestType, formData.vendorType]);
  const venuesListForSelect = useMemo(() => {
    if (formData.interestType !== "venue" || !formData.venueType) return [];
    return businessesInCity.filter(
      (b) =>
        b?.businessType === "venue" &&
        (b.type || "").toLowerCase() === (formData.venueType || "").toLowerCase(),
    );
  }, [businessesInCity, formData.interestType, formData.venueType]);

  useEffect(() => {
    dispatch(onGetBusinesses({ limit: 50, offset: 0 }));
  }, [dispatch]);

  useEffect(() => {
    if (isLogin && loginUserData) {
      setFormData((prev) => ({
        ...prev,
        name: loginUserData?.name,
        email: loginUserData?.email,
        phone: loginUserData?.phone,
      }));
    }
  }, [isLogin, loginUserData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "interestType") {
        next.vendorType = "";
        next.venueType = "";
        next.selectedVendorId = "";
        next.selectedVenueId = "";
      } else if (name === "vendorType") {
        next.selectedVendorId = "";
      } else if (name === "venueType") {
        next.selectedVenueId = "";
      }
      return next;
    });
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email is invalid";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^(\+91|0)?[6-9]\d{9}$/.test(formData.phone.replace(/\s+/g, "")))
      newErrors.phone = "Please enter a valid 10-digit phone number";
    if (!formData.eventdate.trim())
      newErrors.eventdate = "Event date is required";
    if (!formData.eventtype) newErrors.eventtype = "Event type is required";
    if (!formData.nooguests.trim())
      newErrors.nooguests = "Number of guests is required";
    else if (
      isNaN(Number(formData.nooguests)) ||
      Number(formData.nooguests) < 1
    )
      newErrors.nooguests = "Enter a valid number";
    if (!formData.city.trim()) newErrors.city = "City / location is required";

    if (formData.interestType === "vendor") {
      if (!formData.vendorType)
        newErrors.vendorType = "Vendor type is required";
      if (!formData.selectedVendorId)
        newErrors.selectedVendorId = "Please select a vendor";
    } else if (formData.interestType === "venue") {
      if (!formData.venueType) newErrors.venueType = "Venue type is required";
      if (!formData.selectedVenueId)
        newErrors.selectedVenueId = "Please select a venue";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
        dispatch(onEnquiryPost({...formData, reference_id:formData?.selectedVendorId || formData?.selectedVenueId}));
    }
  };
  useEffect(() => {
    const code = enquiryData?.postStatusCode;
    if (code === "201" || code === 201) {
      setShowThankYou(true);
      dispatch(onEnquiryPostReset());
    }
  }, [dispatch, enquiryData?.postStatusCode]);
  return (
    <div className="enquiry-page">
      <Link to="/" className="enquiry-page-back" aria-label="Back to home">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        <span className="enquiry-page-back-text">Back</span>
      </Link>

      {/* Full-width hero – one-page style */}
      <header className="enquiry-hero">
        <div className="enquiry-hero-bg" aria-hidden="true" />
        <div className="enquiry-hero-inner">
          <h1 className="enquiry-hero-title">
            {venueId ? "Enquiry" : "Plan your dream event"}
            {venueId &&
              (() => {
                const business = businessesList?.find((v) => v?.id === venueId);
                const type = venueIdParam?"Venue":"Vendor";
                const name = business?.name;
                const businessCity = business?.city ?? city;
                if (!type && !name) return null;
                return (
                  <span className="enquiry-hero-title-highlight">
                    <span className="enquiry-hero-title-for">
                      {" "}
                      for {type ? capsFirstLetter(type) : ""}
                    </span>
                    {name ? (
                      <Link
                        to={
                          venueIdParam
                            ? `/venue/${business.id}`
                            : `/vendors/vendor/${encodeURIComponent(String(business.id))}`
                        }
                        className="enquiry-hero-title-name"
                      >
                        {" "}
                        {name}
                      </Link>
                    ) : null}
                    {businessCity ? (
                      <span className="enquiry-hero-title-in">
                        {" "}
                        in{" "}
                        <span className="enquiry-hero-title-city">
                          {businessCity}
                        </span>
                      </span>
                    ) : null}
                  </span>
                );
              })()}
          </h1>
          <p className="enquiry-hero-subtitle">
            {venueId && businessesList?.find((v) => v?.id === venueId)
              ? "Share your details and we'll get back with a personalised response for this listing."
              : "Share your details and we'll help you find the perfect venue and vendors. One form, personalised recommendations."}
          </p>
          <ul className="enquiry-trust-list">
            {TRUST_ITEMS.map((item, i) => (
              <li key={i} className="enquiry-trust-item">
                <span className="enquiry-trust-icon">{item.icon}</span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </header>

      {/* One-page form – full width content, sections as blocks */}
      <main className="enquiry-main">
        <div className="enquiry-content">
          {showThankYou ? (
            <section className="enquiry-block">
              <div className="enquiry-block-header">
                <span className="enquiry-block-num">✓</span>
                <h2 className="enquiry-block-title">Thank you!</h2>
              </div>
              <p>
                Your enquiry has been submitted successfully. Our team will get
                back to you shortly.
              </p>
              <Link to="/" className="enquiry-submit-btn" style={{ display: "inline-flex", textDecoration: "none", justifyContent: "center" }}>
                Back to Home
              </Link>
            </section>
          ) : (
          <form className="enquiry-form" onSubmit={handleSubmit}>
            <section className="enquiry-block">
              <div className="enquiry-block-header">
                <span className="enquiry-block-num">1</span>
                <h2 className="enquiry-block-title">Personal details</h2>
              </div>
              <div className="enquiry-form-row">
                <div className="form-group">
                  <label htmlFor="enquiry-name" className="form-label">
                    Your name *
                  </label>
                  <input
                    type="text"
                    id="enquiry-name"
                    name="name"
                    className={`form-input ${errors.name ? "input-error" : ""}`}
                    placeholder="Full name"
                    value={formData.name}
                    onChange={handleChange}
                    disabled={isSubmitting || isLogin}
                  />
                  {errors.name && (
                    <span className="error-message">{errors.name}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="enquiry-email" className="form-label">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="enquiry-email"
                    name="email"
                    className={`form-input ${errors.email ? "input-error" : ""}`}
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isSubmitting || isLogin}
                  />
                  {errors.email && (
                    <span className="error-message">{errors.email}</span>
                  )}
                </div>
              </div>
              <div className="enquiry-form-row">
                <div className="form-group">
                  <label htmlFor="enquiry-phone" className="form-label">
                    Phone *
                  </label>
                  <input
                    type="tel"
                    id="enquiry-phone"
                    name="phone"
                    className={`form-input ${errors.phone ? "input-error" : ""}`}
                    placeholder="10-digit mobile number"
                    value={formData.phone}
                    onChange={handleChange}
                    disabled={isSubmitting || isLogin}
                  />
                  {errors.phone && (
                    <span className="error-message">{errors.phone}</span>
                  )}
                </div>
                {city && venueId ? null : (
                  <div className="form-group">
                    <label htmlFor="enquiry-city" className="form-label">
                      City *
                    </label>
                    <select
                      name="city"
                      id="enquiry-city"
                      className={`form-input form-select ${errors.city ? "input-error" : ""}`}
                      value={formData.city}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    >
                      <option value="">Select City</option>
                      {cities.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                    {errors.city && (
                      <span className="error-message">{errors.city}</span>
                    )}
                  </div>
                )}
              </div>
            </section>

            <section className="enquiry-block">
              <div className="enquiry-block-header">
                <span className="enquiry-block-num">2</span>
                <h2 className="enquiry-block-title">Event details</h2>
              </div>
              <div className="enquiry-form-row">
                <div className="form-group">
                  <label htmlFor="enquiry-eventdate" className="form-label">
                    Event date *
                  </label>
                  <input
                    type="date"
                    id="enquiry-eventdate"
                    name="eventdate"
                    className={`form-input ${errors.eventdate ? "input-error" : ""}`}
                    value={formData.eventdate}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  {errors.eventdate && (
                    <span className="error-message">{errors.eventdate}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="enquiry-eventtype" className="form-label">
                    Event type *
                  </label>
                  <select
                    id="enquiry-eventtype"
                    name="eventtype"
                    className={`form-input form-select ${errors.eventtype ? "input-error" : ""}`}
                    value={formData.eventtype}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  >
                    {EVENT_TYPES.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                  {errors.eventtype && (
                    <span className="error-message">{errors.eventtype}</span>
                  )}
                </div>
              </div>
              <div className="enquiry-form-row">
                <div className="form-group">
                  <label
                    htmlFor="enquiry-numberOfGuests"
                    className="form-label"
                  >
                    Number of guests *
                  </label>
                  <input
                    type="number"
                    id="enquiry-numberOfGuests"
                    name="nooguests"
                    min="1"
                    max="10000"
                    className={`form-input ${errors.nooguests ? "input-error" : ""}`}
                    placeholder="Approximate count"
                    value={formData.nooguests}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  {errors.nooguests && (
                    <span className="error-message">{errors.nooguests}</span>
                  )}
              </div>
              <div className="form-group">
                <label htmlFor="enquiry-budget" className="form-label">
                  Budget range (optional)
                </label>
                <input
                  type="text"
                  id="enquiry-budget"
                  name="budget"
                  className="form-input"
                  placeholder="e.g. 2-5 Lakhs, or leave blank"
                  value={formData.budget}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </div>
              </div>
           
            </section>

            {venueId ? null : (
              <section
                className={`enquiry-block enquiry-block-interest ${!hasStep1City ? "enquiry-block-disabled" : ""}`}
              >
                <div className="enquiry-block-header">
                  <span className="enquiry-block-num">3</span>
                  <h2 className="enquiry-block-title">
                    What are you looking for?
                  </h2>
                </div>
                {!hasStep1City && (
                  <div className="enquiry-step-info" role="status">
                    <svg
                      className="enquiry-step-info-icon"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      aria-hidden
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 16v-4M12 8h.01" />
                    </svg>
                    <p className="enquiry-step-info-text">
                      Please select city from Step 1 first. Then you can choose Vendor or Venue and pick from the list.
                    </p>
                  </div>
                )}
                <p className="enquiry-radio-hint">
                  Choose one option, then select type and pick from the list
                  (both required).
                </p>
                <div className="enquiry-radio-group">
                  <label className="enquiry-radio-label">
                    <input
                      type="radio"
                      name="interestType"
                      value="vendor"
                      checked={formData.interestType === "vendor"}
                      onChange={handleChange}
                      disabled={isSubmitting || !hasStep1City}
                      className="enquiry-radio-input"
                    />
                    <span className="enquiry-radio-text">Vendor</span>
                  </label>
                  <label className="enquiry-radio-label">
                    <input
                      type="radio"
                      name="interestType"
                      value="venue"
                      checked={formData.interestType === "venue"}
                      onChange={handleChange}
                      disabled={isSubmitting || !hasStep1City}
                      className="enquiry-radio-input"
                    />
                    <span className="enquiry-radio-text">Venue</span>
                  </label>
                </div>

                {formData.interestType === "vendor" && (
                  <div className="enquiry-interest-fields">
                    <div className="form-group">
                      <label
                        htmlFor="enquiry-vendorType"
                        className="form-label"
                      >
                        Vendor type *
                      </label>
                      <select
                        id="enquiry-vendorType"
                        name="vendorType"
                        className={`form-input form-select ${errors.vendorType ? "input-error" : ""}`}
                        value={formData.vendorType}
                        onChange={handleChange}
                        disabled={isSubmitting || !hasStep1City}
                      >
                        <option value="">
                          {hasStep1City && vendorTypeOptionsDynamic.length === 0
                            ? "No vendors in this city"
                            : "Select vendor type"}
                        </option>
                        {vendorTypeOptionsDynamic.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      {errors.vendorType && (
                        <span className="error-message">
                          {errors.vendorType}
                        </span>
                      )}
                    </div>
                    {formData.vendorType && (
                      <div className="form-group">
                        <label
                          htmlFor="enquiry-selectedVendor"
                          className="form-label"
                        >
                          Select vendor *
                        </label>
                        <select
                          id="enquiry-selectedVendor"
                          name="selectedVendorId"
                          className={`form-input form-select ${errors.selectedVendorId ? "input-error" : ""}`}
                          value={formData.selectedVendorId}
                          onChange={handleChange}
                          disabled={isSubmitting || !hasStep1City}
                        >
                          <option value="">
                            {vendorsListForSelect.length === 0
                              ? "No vendors of this type in this city"
                              : "Select a vendor"}
                          </option>
                          {vendorsListForSelect.map((v) => (
                            <option key={v.id} value={v.id}>
                              {v.name ?? `Vendor ${v.id}`}
                              </option>
                            ))}
                        </select>
                        {errors.selectedVendorId && (
                          <span className="error-message">
                            {errors.selectedVendorId}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {formData.interestType === "venue" && (
                  <div className="enquiry-interest-fields">
                    <div className="form-group">
                      <label htmlFor="enquiry-venueType" className="form-label">
                        Venue type *
                      </label>
                      <select
                        id="enquiry-venueType"
                        name="venueType"
                        className={`form-input form-select ${errors.venueType ? "input-error" : ""}`}
                        value={formData.venueType}
                        onChange={handleChange}
                        disabled={isSubmitting || !hasStep1City}
                      >
                        <option value="">
                          {hasStep1City && venueTypeOptionsDynamic.length === 0
                            ? "No venues in this city"
                            : "Select venue type"}
                        </option>
                        {venueTypeOptionsDynamic.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      {errors.venueType && (
                        <span className="error-message">
                          {errors.venueType}
                        </span>
                      )}
                    </div>
                    {formData.venueType && (
                      <div className="form-group">
                        <label
                          htmlFor="enquiry-selectedVenue"
                          className="form-label"
                        >
                          Select venue *
                        </label>
                        <select
                          id="enquiry-selectedVenue"
                          name="selectedVenueId"
                          className={`form-input form-select ${errors.selectedVenueId ? "input-error" : ""}`}
                          value={formData.selectedVenueId}
                          onChange={handleChange}
                          disabled={isSubmitting || !hasStep1City}
                        >
                          <option value="">
                            {venuesListForSelect.length === 0
                              ? "No venues of this type in this city"
                              : "Select a venue"}
                          </option>
                          {venuesListForSelect.map((b) => (
                            <option key={b.id} value={b.id}>
                              {b.name ?? `Venue ${b.id}`}
                                </option>
                          ))}
                        </select>
                        {errors.selectedVenueId && (
                          <span className="error-message">
                            {errors.selectedVenueId}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </section>
            )}

            <section className="enquiry-block">
              <div className="enquiry-block-header">
                <span className="enquiry-block-num">{venueId ? "3" : "4"}</span>
                <h2 className="enquiry-block-title">Tell us more</h2>
              </div>
              <div className="form-group">
                <label htmlFor="enquiry-description" className="form-label">
                  Description / Requirements (optional)
                </label>
                <textarea
                  id="enquiry-description"
                  name="descrip"
                  className={`form-input form-textarea ${errors.descrip ? "input-error" : ""}`}
                  placeholder="Tell us about your event, what you need (venue, catering, decor, etc.), timings, and any specific requirements..."
                  value={formData.descrip}
                  onChange={handleChange}
                  rows={5}
                  disabled={isSubmitting}
                />
              </div>
            </section>

            <button
              type="submit"
              className="enquiry-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="enquiry-submit-spinner" aria-hidden="true" />
                  Sending...
                </>
              ) : (
                "Send enquiry"
              )}
            </button>
            {isLogin ? null : (
              <p className="enquiry-signin">
                Already have an account?{" "}
                <Link to="/login" className="enquiry-link">
                  Sign in
                </Link>
              </p>
            )}
          </form>
          )}
        </div>
      </main>
    </div>
  );
}

export default EnquiryPage;
